import React from 'react';
import ReactDataGrid from "@inovua/reactdatagrid-community";
import {useTranslation} from "react-i18next";
import "@inovua/reactdatagrid-community/index.css";

const ReactDataGridLocaled = (props) => {
    const {t} = useTranslation();

    const i18nGrid = {
        perPageText: t('perPageText'),
        pageText: t('pageText'),
        ofText: t('ofText'),
        showingText: t('showingText'),
        clearAll: t('clearAll'),
        clear: t('clear'),
        showFilteringRow: t('showFilteringRow'),
        hideFilteringRow: t('hideFilteringRow'),
        enable: t('enable'),
        disable: t('disable'),
        sortAsc: t('sortAsc'),
        sortDesc: t('sortDesc'),
        unsort: t('unsort'),
        group: t('group'),
        ungroup: t('ungroup'),
        lockStart: t('lockStart'),
        lockEnd: t('lockEnd'),
        unlock: t('unlock'),
        columns: t('columns'),
        contains: t('contains'),
        startWith: t('startWith'),
        endsWith: t('endsWith'),
        notContains: t('notContains'),
        notEquals: t('notEquals'),
        equals: t('equals'),
        notEmpty: t('notEmpty'),
        empty: t('empty'),
        lt: t('lt'),
        lte: t('lte'),
        gt: t('gt'),
        gte: t('gte'),
        between: t('between'),
        notBetween: t('notBetween'),
        In: t('In'),
        notIn: t('notIn'),
    };

    return (
        <ReactDataGrid
            {...props}
            i18n={i18nGrid}
        />
    );
};

export default ReactDataGridLocaled;
